/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: { currentUser?: any }) {
  const { currentUser } = initialState || {};

 
  return {
    ...currentUser?.access,
    canAdmin: false,
    canHome: true,
  };
}
